// No imports required

export const STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION = 'structure-of-acra-entity-registered-information';
export const COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES =
    'commencement-of-provision-and-or-operation-of-telecommunication-services';
export const COMPLIANCE_DECLARATION = 'compliance-declaration';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const SERVICES = 'services';
export const CALL_BACK_CALL_RE_ORIGINATION_SERVICES_NON_PREPAID =
    'call-back-call-re-origination-services-non-prepaid';
export const INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID =
    'internet-based-voice-and-data-services-non-prepaid';
export const STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID =
    'store-and-retrieve-value-added-network-services-non-prepaid';
export const STORE_AND_FORWARD_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID =
    'store-and-forward-value-added-network-services-non-prepaid';
export const INTERNATIONAL_CALLING_CARD_SERVICES_NON_PREPAID =
    'international-calling-card-services-non-prepaid';
export const AUDIOTEX_SERVICE = 'audiotex-service';
export const RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES =
    'resale-of-public-switched-telecommunication-services';
export const PUBLIC_CHAIN_PAYPHONE_SERVICES_NON_PREPAID_OPTIONAL =
    'public-chain-payphone-services-non-prepaid-optional';

export const SBOC_LICENCE = [
    {
        sectionID: STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION,
        sectionName: 'Structure of ACRA Entity Registered Information',
        fieldList: [
            {
                id: 'required-information-will-be-attached',
                mainLabel:
                    'Include parent company, where applicable, subsidiaries and other interests of the group in Singapore and abroad, details of key personnel and management structure.',
                label: 'Required Information will be attached',
                type: 'text',
                span: 12
            },
            {
                id: 'question-one',
                mainLabel: 'Question 1',
                label: 'Have any of the directors/managers/partners (as defined in the Companies Act 1967/Limited Liability Partnership Act) been a director/manager/partner of an ACRA Entity which has gone into liquidation, placed in official receivership, or insolvent (whether while he was a director/manager/partner or within 3 years of his ceasing to be director/manager/partner)?',
                type: 'text',
                span: 12
            },
            {
                id: 'if-yes-question-one',
                label: 'If yes for Question 1, please provide details',
                type: 'text',
                span: 12
            },
            {
                id: 'question-two',
                mainLabel: 'Question 2',
                label: 'Have any of the directors/managers/partners been a director/manager/partner of an ACRA Entity whose telecommunications licence(s) had been revoked by IMDA for breach of licence condition(s) (whether while he was a director/manager/partner or within 3 years of hisceasing to be a director/manager/partner)?',
                type: 'text',
                span: 12
            },
            {
                id: 'if-yes-question-two',
                label: 'If yes for Question 2, please provide details',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES,
        sectionName: 'Commencement of provision and/or operation of telecommunication services',
        fieldList: [
            {
                id: 'have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application',
                mainLabel: 'Provisioning/operation of any of the telecommunication services',
                label: 'Have you commenced provision/operation of any of the telecommunications services applied for in this application?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-state-the-date-of-commencement',
                label: 'Please state the date of commencement',
                type: 'text',
                span: 12
            },
            {
                id: 'number-of-users',
                label: 'Number of users',
                type: 'text',
                span: 12
            },
            {
                id: 'profile-of-users',
                label: 'Profile of users',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: COMPLIANCE_DECLARATION,
        sectionName: 'Compliance Declaration',
        fieldList: [
            {
                id: 'declaration-1',
                mainLabel: "Declaration 1",
                label: "I/We hereby declare that the above services will be offered in accordance with all applicable laws and regulations including without limitation: a) the Telecommunications Act 1999; b) the Telecommunications (Class Licences) Regulations; c) the Code of Practice for Provision of Premium Rate Services; and d) Guidelines for Submission of Services-Based Operations Licence.",
                span: 12,
                type: 'text'
            },
            {
                id: 'declaration-2',
                mainLabel: "Declaration 2",
                label: "I/We acknowledge that any false or misleading information submitted to IMDA will render the Registration granted as null and void",
                span: 12,
                type: 'text'
            },
            {
                id: 'declaration-3',
                mainLabel: "Declaration 3",
                label: "I/We hereby declare that all the information (including all attachments) submitted to IMDA in this Registration is true to the best of my/our knowledge, information and belief.",
                span: 12,
                type: 'text'
            },
            {
                id: 'declaration-4',
                mainLabel: "Declaration 4",
                label: "I/We am/are aware that furnishing false or misleading information attracts penalties under the Telecommunications Act 1999 and/or the Telecommunications (Class Licences) Regulations.",
                span: 12,
                type: 'text'
            },
            {
                id: 'declaration-5',
                mainLabel: "Declaration 5",
                label: "I/We hereby declare the above services to be offered do not require a Services-Based Operations (Individual) Licence, and that in the event of doubt, I/we have sought the necessary clarification from IMDA.",
                span: 12,
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];

export const SBOC_SERVICES = [
    {
        sectionID: CALL_BACK_CALL_RE_ORIGINATION_SERVICES_NON_PREPAID,
        sectionName: 'Call-back / Call Re-origination Services - Non Prepaid',
        fieldList: [
            {
                id: 'call-back',
                label: '',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID,
        sectionName: 'Internet-Based Voice and Data Services - Non Prepaid',
        fieldList: [
            {
                id: 'internet-based',
                label: '',
                type: 'text',
                span: 12
            },
            {
                id: 'internet-based-declaration-1',
                mainLabel: 'Declaration 1',
                label: 'I will only use the public Internet access facilities to provide the proposed Internet-based voice and data services and no leased circuit, Internet-based VPN, Internet Exchange and/or point-to-point connections will be utilised for the proposed service.',
                type: 'text',
                span: 12
            },
            {
                id: 'internet-based-declaration-2',
                mainLabel: 'Declaration 2',
                label: 'I will comply with IMDA\'s National Numbering Plan, which sets out IMDA\'s framework and guidelines on the usage, allocation and assignment of numbers. The National Numbering Plan can be found at IMDA\'s website www.imda.gov.sg.',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID,
        sectionName: 'Store-and-Retrieve (S&R) Value-Added Network Services - Non Prepaid',
        fieldList: [
            {
                id: 'store-and-retrieve',
                label: '',
                type: 'text',
                span: 12
            },
            {
                id: 'leased-circuits',
                label: 'Are you using leased circuits connections?',
                type: 'text',
                span: 12
            },
            {
                id: 'providing-premium',
                label: 'Are you providing premium rate services?',
                type: 'text',
                span: 12
            },
            {
                id: 'able-to-comply',
                label: 'I am able to comply with the code of practice for premium rate services',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: STORE_AND_FORWARD_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID,
        sectionName: 'Store-and-Forward (S&F) Value-Added Network Services - Non Prepaid',
        fieldList: [
            {
                id: 'store-and-forward',
                label: '',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: INTERNATIONAL_CALLING_CARD_SERVICES_NON_PREPAID,
        sectionName: 'International Calling Card (ICC) Services - Non Prepaid',
        fieldList: [
            {
                id: 'international-calling-card',
                label: '',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: AUDIOTEX_SERVICE,
        sectionName: 'Audiotex service',
        fieldList: [
            {
                id: 'audiotex-service',
                type: 'text',
                span: 12
            },
            {
                id: 'other-audiotex-service',
                type: 'text',
                span: 12
            },
            {
                id: 'required-information-audiotex',
                mainLabel: 'Annex 1',
                note: 'Please provide a list of Audiotex Services offered and give full details on the charges*',
                label: 'Required Information of Audiotex Services and charges will be attached',
                type: 'text',
                span: 12
            },
            {
                id: 'audiotex-services-offered',
                label: 'Audiotex Services Offered and Details On The Charges',
                type: 'text',
                span: 12
            },
            {
                id: 'required-information-of-scope',
                label: 'Required Information of scope and types of programmes will be attached',
                type: 'text',
                span: 12
            },
            {
                id: 'scope-and-types-of-programmes',
                label: 'Scope And Types Of Programmes That Will Be Provided By Each Of The Audiotex Services',
                type: 'text',
                span: 12
            },
            {
                id: 'confirm-audiotex-1900',
                label: 'Please confirm that you provide Audiotex Services through the "1900" access line leased from a Facilities-Based Operator.',
                type: 'text',
                span: 12
            },
            {
                id: 'current-call-charge',
                label: 'The current call charge is announced at the beginning of each call.',
                type: 'text',
                span: 12
            },
            {
                id: 'enable-callers',
                label: 'The Audiotex Services do not enable callers to communicate directly in real-time with other callers',
                type: 'text',
                span: 12
            },
            {
                id: 'live-programmes',
                label: 'The Audiotex Services do not provide live programmes.',
                type: 'text',
                span: 12
            },
            {
                id: 'no-delay',
                label: 'There is no delay in starting the announcement or programme.',
                type: 'text',
                span: 12
            },
            {
                id: 'each-audiotex',
                label: 'Each of the Audiotex Service will be assigned a different telephone number.',
                type: 'text',
                span: 12
            },
            {
                id: 'no-interruption',
                label: 'There will be no interruption during the announcement or programme.',
                type: 'text',
                span: 12
            },
            {
                id: 'each-call-period',
                label: 'Each call must be for a maximum period of 10 minutes with an option for the caller to extend his call.',
                type: 'text',
                span: 12
            },
        ]
    },
    {
        sectionID: RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
        sectionName: 'Resale of Public Switched Telecommunication Services',
        fieldList: [
            {
                id: 'resale-of-public-switched-telecommunication-services',
                label: '',
                type: 'text',
                span: 12
            },
            {
                id: 'others-of-public-switched-telecommunication-services',
                label: 'Others of public switched telecommunication services',
                type: 'text',
                span: 12
            },
            {
                id: 'required-information-will-be-attached',
                label: 'Required Information Will Be Attached',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: PUBLIC_CHAIN_PAYPHONE_SERVICES_NON_PREPAID_OPTIONAL,
        sectionName: 'Public Chain Payphone Services - Non Prepaid (Optional)',
        fieldList: [
            {
                id: 'public-chain-payphone-services',
                label: 'Plan Type',
                type: 'text',
                span: 12
            }
        ]
    },
];
